/*  eslint no-shadow: ["error", { "allow": ["state"] }] */
/*  eslint no-param-reassign: ["error", { "props": false }] */
import Vue from "vue";
import Vuex from "vuex";
import { CustomerService } from "@/services/customer.service";
import { HelperService } from "@/services/helper.service";

Vue.use(Vuex);

const state = {
  customers: [],
  customersTemp: [],
  selected: {},
  loading: false,
  totalCount: 0
};

const getters = {
  customers: state => state.customers,
  customersTemp: state => state.customersTemp,
  selectedCustomer: state => state.selected,
  onLoading: state => state.loading,
  total: state => state.totalCount
};

const mutations = {
  setSelected(state, sel) {
    state.selected = sel;
  },
  setList(state, sel) {
    state.customers = sel;
  },
  setTotal(state, sel) {
    state.totalCount = Number(sel);
  },
  setLoading(state, sel) {
    state.loading = sel;
  },
  setTemp(state, sel) {
    state.customersTemp = sel;
  },
};

const actions = {
  async ajaxCustomerSetSelected({ commit }, payload) {
    await HelperService.genericSetSelected(
      commit,
      CustomerService.fetchOne,
      payload.id
    );
  },

  async ajaxCustomerFetchAll({ commit }, payload) {
    console.log("API", payload);
    let searchFilterPagination = HelperService.localToJSONAPIPagination(
      payload
    );
    searchFilterPagination.include = "customer_type,links,tenant";
    await HelperService.genericFetchAll(
      commit,
      CustomerService.fetchAll,
      searchFilterPagination,
      null,
      null
    );
  },

  async ajaxCustomerFetchTemp({ commit }, payload) {
    let searchFilterPagination = HelperService.localToJSONAPIPagination(
      payload
    );
    searchFilterPagination.include = "customer_type,links,tenant";

    await HelperService.tempFetchAll(
      commit,
      CustomerService.fetchAll,
      searchFilterPagination,
      null,
      null
    );
  },

  async ajaxCustomerCreateOrUpdate({ commit }, payload) {
    return HelperService.genericCreateOrUpdate(
      commit,
      CustomerService.createOrUpdate,
      payload
    );
  },

  async ajaxCustomerDelete({ commit }, payload) {
    return HelperService.genericDelete(
      commit,
      CustomerService.delete,
      payload.id
    );
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
